import { Component, Input, SimpleChanges } from '@angular/core';
import {
  ControlContainer,
  FormGroupDirective,
} from '@angular/forms';
import { environment } from '@env/environment';
import { IPropertyInfoEvent } from '@modules/ota-v2/become-agency/models/property-info.model';
import { TranslateService } from '@ngx-translate/core';
import { ToastType } from '@shared/enum/toast-type';
import { MessageService } from 'primeng/api';
import { Subject, Subscription } from 'rxjs';
import { SoctripTranslationService } from 'src/app/services/soctrip-translation/soctrip-translation.service';

@Component({
  selector: 'app-property-photos',
  templateUrl: './property-photos.component.html',
  styleUrls: ['./property-photos.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class PropertyPhotosComponent {
  @Input() generalInfo: any;
  @Input() propertyImg: any;
  @Input() isKeep: boolean;
  @Input() disabled: boolean = false;
  @Input() isDiscardChange: boolean;
  onDestroy$: Subject<void> = new Subject();
  loadingFileFromLocal: boolean = false;
  propertyInfoEvents: IPropertyInfoEvent[];
  propertyInfoEventSub: Subscription;
  dragAreaClass: string = 'dragarea';
  isCallAPI: boolean = false;
  draggedFiles: any[] = [];
  files: any[] = [];
  mainPhoto: number = 0;
  sessionId: string = '';
  maximum: number = 4;
  isDisabled: boolean = false;
  isCheckBoxDirty: boolean = false;
  confirmSubject = new Subject<boolean>();
  confirm$ = this.confirmSubject.asObservable();
  isCancel = false;
  imageUrls: string[] = [];
  imageObjects: {
    file: File;
    url: string;
  }[];
  newFiles: any[] = [];
  isShowSaveAsDraftBtn = true;
  lastPropertyImage: any;

  selectedImageUrl: string | null = null;

  constructor(
    private soctripTranslationService: SoctripTranslationService,
    private translateService: TranslateService,
    private messageService: MessageService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['isDiscardChange'] ||
      (changes['generalInfo'] &&
        this.generalInfo?.property_image &&
        JSON.stringify(this.generalInfo.property_image) !==
          JSON.stringify(this.lastPropertyImage))
    ) {
      const data = this.generalInfo.property_image;

      const files = [
        {
          image_id: data.image_overview_id,
          url: `${environment.STORAGE_SERVICE_API_BASE_PATH}/files/web/${data.image_overview_id}.webp`,
          file: this.urlToFile(
            `${environment.baseURL}/storage/files/web/${data.image_overview_id}.webp`,
            ''
          ),
        },
      ];

      const imgs = (data.image_ids || []).map((id: string) => ({
        image_id: id,
        url: `${environment.STORAGE_SERVICE_API_BASE_PATH}/files/web/${id}.webp`,
        file: this.urlToFile(
          `${environment.baseURL}/storage/files/web/${id}.webp`,
          ''
        ),
      }));

      this.draggedFiles = [...files, ...imgs];
      this.files = [...this.draggedFiles];
      this.mainPhoto = 0;
      console.log('draggedFiles:', this.draggedFiles);

      this.lastPropertyImage = JSON.parse(
        JSON.stringify(this.generalInfo.property_image)
      );
    }
  }

  ngOnInit() {
    let temp_profile =
      localStorage.getItem('user_profile') || '{"language":"VI"}';
    this.translateService.use(
      JSON.parse(temp_profile).language.toLowerCase() || 'en'
    );

    this.sessionId = localStorage.getItem(environment.SESSION_ID) + '';
  }

  showImagePopup(url: string) {
    this.selectedImageUrl = url;
  }

  closeImage() {
    this.selectedImageUrl = null;
  }

  urlToFile(url: string, filename: string): File {
    const blob = new Blob([url], { type: '' });
    const file = new File([blob], filename, { type: '' });
    return file;
  }

  ngOnDestroy() {
    for (const item of this.draggedFiles) {
      window.URL.revokeObjectURL(item.url);
    }
  }

  onDelete(index: number) {
    this.draggedFiles.splice(index, 1);
    if (index === this.mainPhoto) {
      this.mainPhoto = 0;
    } else if (index < this.mainPhoto) {
      this.mainPhoto--;
    }
    this.maximum += 1;
    this.isCheckBoxDirty = true;
  }

  onChoose(index: number) {
    this.mainPhoto = index;
    this.isCheckBoxDirty = true;
  }

  onDragOver(event: any) {
    this.dragAreaClass = 'droparea';
    event.preventDefault();
  }

  onDragLeave(event: any) {
    this.dragAreaClass = 'dragarea';
    event.preventDefault();
  }

  onDrop(event: any) {
    this.dragAreaClass = 'dragarea';
    event.preventDefault();
    event.stopPropagation();
    let files: FileList = event.dataTransfer.files;
    this.addPhotos(files);
  }

  async onFileChange(event: any) {
    this.loadingFileFromLocal = true;
    let files: FileList = event.target.files;
    await this.addPhotos(files);
    const input = event.target as HTMLInputElement;
    input.value = '';
    this.loadingFileFromLocal = false;
  }

  async addPhotos(files: any) {
    let fileTypeIsValid: boolean = false;
    let fileSizeIsValid: boolean = false;
    let imageSizeIsValid: boolean = false;
    let duplicateFiles: string[] = [];
    if (files) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        const isDuplicate = this.draggedFiles.some(
          (existingFile) =>
            existingFile.file.name === file.name &&
            existingFile.file.size === file.size
        );

        if (isDuplicate) {
          duplicateFiles.push(file.name);
          continue;
        }
        if (!this.isFileTypeAllowed(file.type)) {
          fileTypeIsValid = true;
          continue;
        }
        if (!this.isFileSizeValid(file.size)) {
          fileSizeIsValid = true;
          continue;
        }

        const url = window.URL.createObjectURL(file);

        const image = new Image();
        image.src = url;

        const imageSizeValid = await this.isImageSizeValidAsync(url);
        if (!imageSizeValid) {
          imageSizeIsValid = true;
        } else {
          this.draggedFiles.push({ file, url });
          this.maximum -= 1;
          this.isCheckBoxDirty = true;
          //   this.checkShowSaveBtn();
        }
      }
    }

    if (duplicateFiles.length > 0) {
      this.messageService.add({
        key: 'FILE_ERROR',
        severity: ToastType.ERROR,
        detail: this.soctripTranslationService.getTranslation(
          'OTA.PROPERTY_PHOTOS.DUPLICATE_PHOTO'
        ),
      });
    }

    if (fileTypeIsValid) {
      this.messageService.add({
        key: 'FILE_ERROR',
        severity: ToastType.ERROR,
        detail: this.soctripTranslationService.getTranslation(
          'OTA.PROPERTY_PHOTOS.PHOTO_TYPE_INVALID'
        ),
      });
    }
    if (fileSizeIsValid) {
      this.messageService.add({
        key: 'FILE_ERROR',
        severity: ToastType.ERROR,
        detail: this.soctripTranslationService.getTranslation(
          'OTA.PROPERTY_PHOTOS.FILE_SIZE_INVALID'
        ),
      });
    }
    if (imageSizeIsValid) {
      this.messageService.add({
        key: 'FILE_ERROR',
        severity: ToastType.ERROR,
        detail: this.soctripTranslationService.getTranslation(
          'OTA.PROPERTY_PHOTOS.MIN_SIZE_INVALID'
        ),
      });
    }
  }

  async isImageSizeValidAsync(url: string): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const image = new Image();
      image.src = url;

      image.onload = () => {
        if (!this.isImageSizeValid(image)) {
          resolve(false);
        } else {
          resolve(true);
        }
      };
    });
  }

  isFileTypeAllowed(fileType: string): boolean {
    const allowedMimeTypes = ['image/png', 'image/jpeg'];
    return allowedMimeTypes.includes(fileType);
  }

  isFileSizeValid(fileSize: number): boolean {
    const minSize = 10 * 1024; // 10 KB
    const maxSize = 20 * 1024 * 1024; // 20 MB
    return fileSize >= minSize && fileSize <= maxSize;
  }

  isImageSizeValid(image: HTMLImageElement): boolean {
    const minWidth = 800;
    const minHeight = 600;
    return image.width >= minWidth && image.height >= minHeight;
  }

  validate() {
    this.isCheckBoxDirty = true;
    let error = [];
    if (this.draggedFiles?.length < 4) {
      const msg = this.translateService.instant(
        'OTA.PROPERTY_PHOTOS.PROPERTY_PHOTOS'
      );
      error.push(msg);
    }
    return error;
  }

  showError(detail: string) {
    this.messageService.add({
      key: 'FILE_ERROR',
      severity: ToastType.ERROR,
      detail: detail,
    });
  }

  public refreshPhotos(propertyImage: any) {
    const mainImageId =
      propertyImage.image_overview_id?.image_overview_id ||
      propertyImage.image_overview_id;

    const files = [
      {
        image_id: mainImageId,
        url: `${environment.STORAGE_SERVICE_API_BASE_PATH}/files/web/${mainImageId}.webp`,
        file: this.urlToFile(
          `${environment.baseURL}/storage/files/web/${mainImageId}.webp`,
          ''
        ),
      },
    ];

    const imgs = (propertyImage.image_ids || []).map((img: any) => {
      const id = img?.image_id || img;
      return {
        image_id: id,
        url: `${environment.STORAGE_SERVICE_API_BASE_PATH}/files/web/${id}.webp`,
        file: this.urlToFile(
          `${environment.baseURL}/storage/files/web/${id}.webp`,
          ''
        ),
      };
    });

    this.draggedFiles = [...files, ...imgs];
    this.mainPhoto = 0;
  }
}
